<template>
  <div>
    <DataTable
      v-model:expandedRows="expandedRows"
      v-model:filters="filters"
      :value="items"
      :loading="loading"
      :rows="10"
      :totalRecords="total"
      :rowsPerPageOptions="[10, 25, 50]"
      filterDisplay="row"
      class="p-datatable-sm"
      dataKey="id"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Memuat {first} dari {last} data dari total {totalRecords}"
      row-hover
      paginator
      scrollable
      lazy
      @page="onPage($event)"
      @sort="onSort($event)"
      @filter="onFilter($event)"
    >
      <template #empty>
        <div class="text-center">Tidak ada data.</div>
      </template>
      <template #loading>
        <div class="text-center">Memuat data, harap tunggu...</div>
      </template>
      <Column style="min-width: 3rem; flex: initial" header="" expander />
      <Column
        field="kb_no"
        header="No kontra"
        style="min-width: 12rem"
        sortable
      >
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @keydown.enter="filterCallback()"
          />
        </template>
      </Column>
      <Column
        dataType="date"
        filter-field="order_between"
        field="kb_at"
        header="Tanggal"
        style="min-width: 19rem"
        headerStyle="min-width: 19rem"
        sortable
      >
        <template #body="{ data }">
          {{ formatDate(data.kb_at) }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <CalendarFilter
            ref="calendarFilter"
            v-model="filterModel.value"
            @select="filterCallback()"
          />
        </template>
      </Column>
      <Column
        dataType="date"
        filter-field="order_between"
        field="kembali_at"
        header="Tanggal kembali"
        style="min-width: 14rem"
        headerStyle="min-width: 14rem"
        sortable
      >
        <template #body="{ data }">
          {{ formatDate(data.kembali_at) }}
        </template>
      </Column>
      <Column
        field="supplier.nama"
        sort-field="supplier"
        filter-field="supplier"
        header="Supplier"
        sortable
        style="min-width: 23rem"
      >
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @keydown.enter="filterCallback()"
          />
        </template>
      </Column>
      <Column
        field="jumlah"
        header="Total"
        style="min-width: 60px; max-width: 200px; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.jumlah) }}
        </template>
      </Column>
      <Column style="flex-grow: 1; justify-content: flex-end" class="column-action__30">
        <template #body="{ data }">
          <Button
            v-if="data.jenis_kontrabon === 'telat'"
            type="button"
            icon="pi pi-print"
            class="p-button-outlined p-button-primary p-button-text mr-2"
            v-tooltip.top="'Surat telat kontra bon'"
            @click="$emit('printtelat', data)"
          />
          <Button
            type="button"
            icon="pi pi-print"
            class="p-button-outlined p-button-secondary p-button-text mr-2"
            v-tooltip.top="'Surat terima kontra bon'"
            @click="$emit('print', data)"
          />
          <Button
            type="button"
            icon="pi pi-pencil"
            class="p-button-outlined p-button-secondary p-button-text"
            @click="$emit('edit', data)"
          />
          <!-- <Button
            type="button"
            icon="pi pi-trash"
            class="p-button-outlined p-button-danger p-button-text"
            @click="$emit('delete', data)"
          /> -->
        </template>
      </Column>
      <template #expansion="slotProps">
        <div class="card">
          <DataTable
            v-model:expandedRows="expandedRows"
            :value="slotProps.data.detail"
            class="p-datatable-sm"
            showGridlines
            scrollable
          >
            <Column field="pi_no" header="No Bukti" style="min-width: 9rem">
              <template #body="{ data }">
                <div v-if="data.pi_no">
                  {{ data.pi_no }}
                </div>
                <div v-if="data.pr_no">
                  {{ data.pr_no }}
                </div>
              </template>
            </Column>
            <Column field="pi_at" header="Tgl. Bukti" style="min-width: 7rem">
              <template #body="{ data }">
                <div v-if="data.pi_at">
                  {{ formatDate(data.pi_at) }}
                </div>
                <div v-if="data.pr_at">
                  {{ formatDate(data.pr_at) }}
                </div>
              </template>
            </Column>
            <Column field="inv_no" header="No Faktur" style="min-width: 15rem">
              <template #body="{ data }">
                {{ data.inv_no }}
              </template>
            </Column>
            <Column field="inv_at" header="Tgl. faktur" style="min-width: 7rem">
              <template #body="{ data }">
                {{ formatDate(data.inv_at) }}
              </template>
            </Column>
            <Column
              field="jumlah"
              header="Jumlah"
              style="min-width: 150px; flex-grow: 1; justify-content: flex-end"
            >
              <template #body="{ data }">
                <div v-if="data.pi_no">
                  {{ formatCurrency(data.jumlah) }}
                </div>
                <div v-if="data.pr_no">
                  {{ formatCurrency(-Math.abs(data.jumlah)) }}
                </div>
              </template>
            </Column>
          </DataTable>
        </div>
      </template>
    </DataTable>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import { formatCurrency, formatDate } from '@/helpers'
import CalendarFilter from '@/components/CalendarFilter'

export default {
  components: {
    CalendarFilter,
  },
  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    gridOptions: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      expandedRows: [],
      options: this.gridOptions,
      filters: {
        kb_no: { value: null, matchMode: FilterMatchMode.CONTAINS },
        order_between: { value: null, matchMode: FilterMatchMode.CONTAINS },
        supplier: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    }
  },
  watch: {
    'options.filters'(value) {
      if (!value.order_between.value) {
        this.$refs.calendarFilter.clearValueOnly()
      }
    },
  },
  methods: {
    onPage(e) {
      e.page = e.page + 1
      e.sortField = this.options.sortField
      e.sortOrder = this.options.sortOrder
      this.options = e
      this.options.filters = this.filters
      this.loadData()
    },
    onSort(e) {
      this.options = e
      this.loadData()
    },
    onFilter() {
      this.options.page = 1
      this.options.filters = this.filters
      this.loadData()
    },
    loadData() {
      this.$emit('request', this.options)
    },
    formatCurrency(value, minDigit = 0, maxDigit = 0) {
      return formatCurrency(value, minDigit, maxDigit)
    },
    formatDate(value) {
      return formatDate(value)
    },
  },
}
</script>
